import React from "react";

export default function MySQL_FLOOR() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_FLOOR</h1>
      <p>This is the MySQL_FLOOR component generated from the SQL JSON.</p>
    </div>
  );
}
